import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { getResponsiveSize } from '../../utils/responsive';
import globalStyles from '../../global';

const Interested = ({ title, content, buttonText }) => {
    const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  
    return (
      <Box
        sx={[
          styles.mainBox,
          { backgroundImage: `url(${imageBaseUrl}backgroundImage.png)` },
        ]}
      >
        <Box sx={styles.innerBox}>
          <Typography variant="h1_white" sx={styles.heading}>
            {title}
          </Typography>
          <Typography
            variant="small_text"
            sx={{
              color: globalStyles.colors.white,
              fontSize: {
                xs: getResponsiveSize(12),
                sm: getResponsiveSize(14),
                md: getResponsiveSize(16),
              },
              textAlign: 'center',
              mt: { xs: getResponsiveSize(2), sm: getResponsiveSize(3) },
            }}
          >
            {content}
          </Typography>
          <Button variant="contained" sx={styles.button2} href="/apply-franchise">
            {buttonText}
          </Button>
        </Box>
      </Box>
    );
  };
  

const styles = {
  mainBox: {
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center', // Center the background image
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    mt: {
      xs: getResponsiveSize(2),
      sm: getResponsiveSize(3),
      md: getResponsiveSize(5),
    },
    pt: {
      xs: getResponsiveSize(6),
      sm: getResponsiveSize(8),
      md: getResponsiveSize(12),
    },
    pb: {
      xs: getResponsiveSize(6),
      sm: getResponsiveSize(8),
      md: getResponsiveSize(12),
    },
  },
  innerBox: {
    width: { xs: '90%', sm: '70%', md: '62%' },
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  heading: {
    color: globalStyles.colors.white,
    fontSize: {
      xs: getResponsiveSize(24),
      sm: getResponsiveSize(32),
      md: getResponsiveSize(40),
    },
    fontFamily: ' "Poppins", serif ',
    fontWeight: 700,
    textAlign: 'center',
  },
  button2: {
    backgroundColor: globalStyles.colors.uclean_gold,
    color: globalStyles.colors.white,
    fontSize: {
      xs: getResponsiveSize(12),
      sm: getResponsiveSize(14),
      md: getResponsiveSize(16),
    },
    fontFamily: ' "Poppins", serif ',
    fontWeight: 500,
    borderRadius: getResponsiveSize(100),
    width: {
      xs: getResponsiveSize(250),
      sm: getResponsiveSize(280),
      md: getResponsiveSize(340),
    },
    height: {
      xs: getResponsiveSize(40),
      sm: getResponsiveSize(50),
      md: getResponsiveSize(60),
    },
    mt: {
      xs: getResponsiveSize(4),
      sm: getResponsiveSize(6),
      md: getResponsiveSize(8),
    },
    '&:hover': {
      color: globalStyles.colors.white,
      backgroundColor: globalStyles.colors.uclean_gold,
    },
  },
};

export default Interested;
